import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo/Seo';
import { getPosts, type BlogPost } from '../../api/blog';

function formatDate(dateStr: string) {
	if (!dateStr) return '';
	return new Date(dateStr).toLocaleDateString('hu-HU', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogListPage() {
	const [posts, setPosts] = useState<BlogPost[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		setLoading(true);
		getPosts()
			.then((res) => setPosts(res.data.data || []))
			.catch(() => setPosts([]))
			.finally(() => setLoading(false));
	}, []);

	return (
		<div className="blog">
			<Seo
				title="Blog - Akku 24+"
				description="Hasznos tudnivalók akkumulátorokról, akkucseréről és téli indításról az Akku 24+ csapatától."
			/>
			<div className="container">
				<div className="blog__head"><h1>Blog</h1></div>

				{loading && <p className="note">Cikkek betöltése…</p>}

				{!loading && posts.length === 0 && <p className="note">Jelenleg nincs elérhető cikk.</p>}

				{!loading && posts.length > 0 && (
					<div className="blog-grid">
						{posts.map((post) => (
							<article key={post.id} className="blog-card">
								<div className="blog-card__body">
									<span className="blog-card__date">{formatDate(post.datetime_created)}</span>
									<h2 className="blog-card__title"><Link to={`/blog/${post.slug}`}>{post.title}</Link></h2>
									{post.lead && <p className="blog-card__lead">{post.lead}</p>}
									<Link className="blog-card__more" to={`/blog/${post.slug}`}>Elolvasom →</Link>
								</div>
							</article>
						))}
					</div>
				)}
			</div>
		</div>
	);
}
